// 事件集合
const eventComparison = {
  orderJumpIM: null, // 订单跳转IM
  paymentAccountChange: null, // 支付账号变更
  walletInitFinished: null, // 钱包初始化完成
  /** layout/wallet.vue：placeWallet 等业务触发 BuyNowPopup */
  showBuyNowInsufficientPopup: null,
  /** cwBootstrap：merchantPlaceWallet 流程结束，延后打开安全密码弹窗 */
  cwBootstrapDepositGateSettled: null,
  /** cwBootstrap 换票后：mine 顶栏 memberInfo（memberInfoRC 非响应式） */
  memberInfoSynced: null,
  /** cwBootstrap 换票后：mine 总资产等余额展示（与 memberInfoSynced 配套） */
  walletBalanceSynced: null,
  /** cwBootstrap：即将发起 queryWalletBalance（与 member 并行）前，mine 先转刷新 icon，与普通 handleRefreshBalance 时序一致 */
  cwBootstrapBalanceQueryImminent: null,
  /** cwBootstrap：会员+余额 prefetch 请求已结束（mine 按最少 1s 规则结束 icon 旋转） */
  cwBootstrapBalanceQuerySettled: null,
};

/**
 * 设置事件监听
 */
export const setEventComparison = (eventName, fn) => {
  eventComparison[eventName] = fn;
};

/**
 * 执行事件
 */
export const runEvent = (eventName, params) => {
  if (eventComparison[eventName]) {
    eventComparison[eventName](params);
  }
};
